import { PrismicError } from "./errors/PrismicError.js";
import { isRepositoryName } from "./isRepositoryName.js";
const getGraphQLEndpoint = (repositoryName) => {
  if (isRepositoryName(repositoryName)) {
    return `https://${repositoryName}.cdn.prismic.io/graphql`;
  } else {
    throw new PrismicError(`An invalid Prismic repository name was given: ${repositoryName}`, void 0, void 0);
  }
};
export {
  getGraphQLEndpoint
};
//# sourceMappingURL=getGraphQLEndpoint.js.map
